var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",style:(_vm.avatarStyle)},[(_vm.user.avatar)?_c('el-avatar',{attrs:{"src":_vm.user.avatar}}):_vm._e(),_c('div',{staticClass:"char-avatar",style:(_vm.charAvatarStyle)},[_vm._v(_vm._s(_vm.firstChar))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }